module.exports = __webpack_public_path__ + "img/xinfarm_logo.3f18e12a.svg";